<template>
  <div class="vacancy">
    <p><a :href="vacancy.url">{{ vacancy.title }}</a><br/>{{ vacancy.description }}</p>
    <a :href="vacancy.url" class="hh"><img :src="hh"/></a>
    <a :href="vacancy.url" class="sj"><img :src="sj"/></a>
  </div>
</template>

<script>
import hh from './hh.png';
import sj from './sj.png';

export default {
  props: {
    vacancy: {
      type: Object,
      default: () => {},
    }
  },
  data () {
    return {
      hh,
      sj
    }
  },
}
</script>

<style lang="scss">
.vacancy {
  display: flex;
  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
  p { font-weight: 300; }
  p a { font-weight: 400; }
}
</style>



// WEBPACK FOOTER //
// Vacancy.vue?796d9172